<template>
  <EditorView>
    <EditorToolbar layout>
      <template slot="elements">
        <div>
          <h4 class="wf-text-blue-700 wf-text-sm wf-lowercase wf-font-bold">
            <i class="fas wf-text-sm fa-clone wf-mr-2"></i>
            <span>Elements</span>
          </h4>
          <div class="wf-border-blue-700 wf-w-8 wf-border-2"></div>
          <div class="wf-mt-5">
            <HeaderSettings/>
            <TopSectionSettings/>
            <BottomSectionSettings/>
            <div class="wf-mt-8">
              <LayoutComponentSettings/>  
            </div>
          </div>
        </div>
      </template>
    </EditorToolbar>
    <EditorPageDevice>
      <EditorLayoutContent/>
    </EditorPageDevice>
    <EditorIconModal/>
    <EditorComponentsModal/>
    <EditorInputModal />
    <div
      v-if="$store.state.editingElement && ! previewMode"
      id="elementToolbar"
      class="wf-absolute wf-top-0 wf-right-0"
      style="width: 320px" :style="elementMenuOpen ? '' : 'margin-right:-248px'"
    >
      <ElementToolbar/>
    </div>
  </EditorView>
</template>

<script>
  import EditorToolbar from '@/components/EditorToolbar'
  import ElementToolbar from '@/components/ElementToolbar'
  import EditorIconModal from '@/components/EditorIconModal'
  import EditorInputModal from '@/components/EditorInputModal'
  import EditorPageDevice from '@/components/EditorPageDevice'
  import HeaderSettings from '@/components/Settings/HeaderSettings'
  import LayoutComponentSettings from '@/components/Settings/LayoutComponentSettings'
  import EditorComponentsModal from '@/components/EditorComponentsModal'
  import TopSectionSettings from '@/components/Settings/TopSectionSettings'
  import BottomSectionSettings from '@/components/Settings/BottomSectionSettings'
  import EditorLayoutContent from '@/components/Layout/EditorLayoutContent'
  export default {
    components: {
      EditorToolbar,
      ElementToolbar,
      TopSectionSettings,
      BottomSectionSettings,
      EditorComponentsModal,
      LayoutComponentSettings,
      HeaderSettings,
      EditorIconModal,
      EditorInputModal,
      EditorPageDevice,
      EditorLayoutContent,
    },
    computed: {
      previewMode() {
        return this.$store.state.previewMode
      },
      elementMenuOpen() {
        return this.$store.state.elementToolbar
      },
    }
  }
</script>